import { Currency } from '@/core/currency/interfaces';

const TRY: Currency = {
    name: 'Turkish Lira',
    demonym: 'Turkish',
    majorSingle: 'Lira',
    majorPlural: 'Lira',
    codeNumeric: '949',
    symbol: 'TL',
    symbolNative: '₺',
    minorSingle: 'Kuruş',
    minorPlural: 'Kuruş',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'TRY',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default TRY;
